function mapYupValidationSchemaErrors(errors) {
  return errors.reduce(
    (acc, error) => ({ ...acc, [error.path]: error.message }),
    {}
  );
}

export default mapYupValidationSchemaErrors;
